import React from 'react';

import PropTypes from 'prop-types';

export default function AttachmentDisplay({
  attachedUrl,
  pdfWrapperClassName = 'tw-h-100',
  recordType,
  timestamp,
}) {
  if (!attachedUrl) return null;

  return recordType === 'pdf' ?
      <div className={pdfWrapperClassName}>
        <iframe
          frameBorder='0'
          height='100%'
          id='hqPdfViewer'
          scrolling='no'
          src={`/pdfjs-3.11.174/web/viewer.html?file=${encodeURIComponent(attachedUrl)}&_=${timestamp}#zoom=auto`}
          title='PDF Viewer'
          width='100%'
        />
      </div>
    : <img
        alt='Attachment'
        className='tw-m-auto tw-block tw-h-auto tw-max-w-[508px]'
        data-element-name='attachmentImg'
        src={`${attachedUrl}?timestamp=${timestamp}`}
      />;
}

AttachmentDisplay.propTypes = {
  attachedUrl: PropTypes.string,
  pdfWrapperClassName: PropTypes.string,
  recordType: PropTypes.string.isRequired,
  timestamp: PropTypes.number,
};
